import { useLayoutEffect, useMemo, useState } from "react";
import { useEventListener } from "./event";

export function useFocus(): [
  boolean,
  { onBlur: () => void; onFocus: () => void },
] {
  const [focus, setFocus] = useState(false);
  const props = useMemo(
    () => ({
      onBlur() {
        setFocus(false);
      },
      onFocus() {
        setFocus(true);
      },
    }),
    [setFocus],
  );
  return [focus, props];
}

export function useTrappedFocus(element: HTMLElement | null) {
  useLayoutEffect(() => {
    element?.focus();
  }, [element]);

  useEventListener(element, "blur", () => {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    element!.focus();
  });
}
